import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FnAppSessionService, FnTimepickerService, FnToasterService } from 'foundation';
import { HeaderService } from './header.service';
import { PosHttpService } from '../services/pos.http.service';
import { Observable } from 'rxjs';
import { RouterServiceService } from '../services/router-service.service';
import { PosTimeService } from '../services/pos.time.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  isMilitaryTime = false;
  appLogo = '';
  appName!: string;
  serverTime = '';
  serverZone = '';
  date = '';
  hour = '';
  minute = '';
  second = '';
  dates!: Date;
  isDark = true;
  employeeData: any;
  timeZoneName = '';

  constructor(
    private router: Router,
    private routerServices: RouterServiceService,
    private timePickerSvcs: FnTimepickerService,
    private headerService: HeaderService,
    private toaster: FnToasterService,
    private posTimerService : PosTimeService,
    private appSessionSvcs: FnAppSessionService
  ) {
    this.isMilitaryTime = this.timePickerSvcs.isMilitaryTime;
  }

  ngOnInit(): void {
    this.getHeader();
    this.setThemeClass();
  }

  getHeader() {
    this.headerService.getHeader().subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp);
        return;
      }
      this.appLogo = resp.appLogo;
      this.appName = resp.appName;
      this.serverTime = resp.serverTime;
      this.timeZoneName = resp.timeZoneName;  // IST
      this.serverZone = resp.serverZone;
      this.dates = new Date(this.serverTime);
      this.parseServerTime(this.serverTime);
      this.posTimerService.setTimeZoneId(resp.serverZone);
  this.posTimerService.setTimeZoneName(resp.timeZoneName);
    });
  }
  changeTheme(isDark: boolean, isReloadPage = true) {
    this.isDark = isDark;
    this.appSessionSvcs.setTheme(this.isDark ? 'DARK' : 'LIGHT', isReloadPage);
  }
  private setThemeClass() {
    this.isDark = this.appSessionSvcs.isDarkTheme();
    if (this.isDark) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }
  parseServerTime(timeString: string): void {
    const [datePart, timePart] = timeString.split(' ');

    this.date = datePart;
    const [hour, minute, second] = timePart.split(':');
    this.hour = hour;
    this.minute = minute;
    this.second = second;
  }
}
